module.exports = "/fonts/element-icons.ttf?732389ded34cb9c52dd88271f1345af9";